<template>
  <div class="container-rules">
    <div class="custom-nav-block" :style="`paddingTop:${barHeight}px`">
      <van-nav-bar class="van-bar" title="" left-arrow @click-left="goBack">
        <template #left>
          <img class="left-nav" src="@/assets/packageAssets/common/arrow01.png" alt="" />
          <span class="tit-left">{{ $t('lang.call.tit1') }}123</span>
        </template>
      </van-nav-bar>
    </div>

    <div class="main right-read">
      <div class="text1">{{ $t('lang.commonM.k320') }}</div>

      <div class="title">{{ $t('lang.commonM.k321') }}</div>
      <div class="text1">1. {{ $t('lang.commonM.k322') }}</div>
      <div class="text1">2. {{ $t('lang.commonM.k323') }}</div>
      <div class="text1">3. {{ $t('lang.commonM.k324') }}</div>
      <div class="text1">4. {{ $t('lang.commonM.k325') }}</div>
      <br />

      <div class="title">{{ $t('lang.commonM.k326') }}</div>
      <div class="text1">1. {{ $t('lang.commonM.k327') }}</div>
      <div class="text1">2. {{ $t('lang.commonM.k328') }}</div>
      <div class="text1">3. {{ $t('lang.commonM.k329') }}</div>
      <div class="text1">4. {{ $t('lang.commonM.k330') }}</div>
      <div class="text1">5. {{ $t('lang.commonM.k331') }}</div>
      <div class="text1">6. {{ $t('lang.commonM.k332') }}</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  }
}
</script>
<style lang="scss" scoped>
.custom-nav-block {
  background-color: #f9f9fb;
}
.container-rules {
  width: 100%;
  min-height: 100vh;
  background: #f9f9fb;
  .main {
    padding: 20px 16px;
    color: #666666;
    line-height: 20px;
    .title {
      font-size: 14px;
      color: #000;
      font-weight: bold;
      margin-bottom: 12px;
    }
    .text1 {
      width: 100%;
      font-size: 14px;
      padding: 0 5px;
      font-family: Inter-Regular;
      font-weight: 400;
      color: #333333;
      margin-bottom: 12px;
    }
    .text2 {
      width: 100%;
      padding: 0 0 5px 15px;
      font-size: 13px;
      font-family: Inter-Regular;
      font-weight: 400;
      color: #666666;
    }
    i {
      color: #333333;
    }
    .text5 {
      color: #000;
    }
    .table {
      width: 100%;
      background: #ffffff;
      box-shadow: 0px 0px 0px 1px rgba(255, 255, 255, 0.15);
      border-radius: 8px;
      margin: 15px 0;
      th {
        width: 100%;
        padding: 10px 0;
        background: #f2f3f8;
        font-size: 12px;
        font-family: Inter-Bold, Inter-Regular;
        font-weight: bold;
        color: #333333;
        line-height: 35px;
      }
      .th1 {
        border-radius: 8px 0 0 0;
      }
      .th3 {
        border-radius: 0 8px 0 0;
      }
      tr {
        display: flex;
        justify-content: space-between;
      }
      td {
        height: 55px;
        line-height: 55px;
        font-size: 14px;
        font-family: Inter-Regular;
        font-weight: 400;
        color: #333333;
      }
      .level {
        width: 40px;
        text-align: center;
      }
      .earning {
        flex: 1;
        width: 180px;
        text-align: center;
      }
      .rate {
        width: 95px;
        text-align: center;
      }
    }
  }
}
</style>
